module.exports = __webpack_public_path__ + "img/afrikai_aktualitasok_mali_referendum.d6793ef0.jpeg";